import React, { FC } from "react";
import { Grid } from "@material-ui/core";
import pretty from "Shared/pretty";
import { activeUserStatuses, EmploymentStatus, UserStatus } from "Shared/types/EmployeeProfiles";
import { DPEmployeeProfile } from "Shared/types/EmployeeProfiles";
import { DPPermissionGate } from "Components/DP";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import DataTable from "Components/Shared/DataTable/DataTable";
import ActivateDeactivateButton from "../../AccountDetailsBanking/ActivateDeactivateButton/ActivateDeactivateButton";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import useStyles from "./styles";

type Props = {
  id: string;
  partnerCanceledAt: DPEmployeeProfile["partnerCanceledAt"];
  providerAccounts: DPEmployeeProfile["providerAccounts"];
}

const PayGroupsTable: FC<Props> = ({
  id,
  partnerCanceledAt,
  providerAccounts,
}) => {
  const classes = useStyles();
  const employmentStatus = partnerCanceledAt
    ? EmploymentStatus.TERMINATED
    : EmploymentStatus.EMPLOYED;

  const { companies } = usePartnerConfig();

  return (
    <DataTable title="Pay Group(s)" >
      {providerAccounts.items.map((account, idx) => (
        <DataTableRow key={idx} rowClassOverride="payGroupItem">
          <Grid item xs={5} className={classes.paygroup}>
            {companies.length === 1
              ? "Default Pay Group"
              : pretty.titleizeWord(account.company.payGroup)
            }
          </Grid>
          <Grid container item xs={3}>{pretty.titleizeWord(account.status)}</Grid>
          <DPPermissionGate permissionKeys={["canUpdateEmployeeStatus"]}>
            <Grid container item xs justify="flex-end" alignItems="flex-start">
              <ActivateDeactivateButton
                employeeProfileId={id}
                providerAccountId={account.id}
                isEnabled={activeUserStatuses.includes(account.status as UserStatus)}
                isUserTerminated={employmentStatus === EmploymentStatus.TERMINATED}
              />
            </Grid>
          </DPPermissionGate>
        </DataTableRow>
      ))}
    </DataTable>
  );
};

export default PayGroupsTable;
